/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import EntidadBancariaService from "common/services/EntidadesBancariasService"
import { editCuentasBancarias } from "./contactoSlice"

const entidadBancaria = new EntidadBancariaService()

export const fethEntidadesBancariasByFilter = createAsyncThunk(
  "EntidadBancaria/byFilters",
  async (param: $TSMigrationFixMe, _: $TSMigrationFixMe) => {
    const { data } = await entidadBancaria.getEntidadesBancarias({
      queryState: param,
    })
    return data
  }
)

export const getEntidadBancariaByIban = createAsyncThunk(
  "EntidadBancaria/by-iban",
  async (
    {
      value: iban,
      entryId,
      accountList,
      addNewEntidadBancaria,
      handleTransformEditedArray,
    }: $TSMigrationFixMe,
    ThunkApi: $TSMigrationFixMe
  ) => {
    const { data } = await entidadBancaria.getEntidadBancariaByIban(iban)

    const editIbanList = handleTransformEditedArray?.(
      accountList,
      {
        iban,
        bic: data.bic,
        entidadBancariaNombre: data.nombre,
        entidadBancariaId: data.id,
        bank: data.id,
        isBicEditable: Boolean(!data.bic),
      },
      entryId
    )

    if (data) {
      ThunkApi.dispatch(addNewEntidadBancaria(data))
      ThunkApi.dispatch(editCuentasBancarias(editIbanList))
    }

    return data
  }
)

const initialState = {
  entidadesBancarias: [],
  entidadBancaria: {},
  loadingEntidadesBancarias: false,
  loadingEntidadBancaria: false,
  totalCount: 0,
  isSelectFilterActive: true,
}

export const entidadBancariaSlice = createSlice({
  name: "entidadBancaria",
  initialState,
  reducers: {
    addNewEntidadBancaria(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.entidadesBancarias = [...state.entidadesBancarias, payload]
    },
    setEntidadBancaria(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.entidadBancaria = payload
    },
    setIsSelectFilterActive(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.isSelectFilterActive = payload
    },
    resetEntidadesBancarias(state: $TSMigrationFixMe) {
      state.entidadesBancarias = []
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fethEntidadesBancariasByFilter.pending, (state) => {
        state.loadingEntidadesBancarias = true
      })
      .addCase(fethEntidadesBancariasByFilter.rejected, (state) => {
        state.loadingEntidadesBancarias = false
      })
      .addCase(
        fethEntidadesBancariasByFilter.fulfilled,
        (state: $TSMigrationFixMe, { payload }) => {
          state.loadingEntidadesBancarias = false
          const entidadesToAdd = payload?.items
          const entidadesBancariasCopy = state.entidadesBancarias.slice()

          if (state.isSelectFilterActive) {
            state.entidadesBancarias = entidadesToAdd.length
              ? entidadesToAdd
              : [{ entidadBancariaNombre: "", entidadBancariaId: "" }]
          } else {
            state.entidadesBancarias = [
              ...entidadesBancariasCopy,
              ...entidadesToAdd,
            ]
          }
          state.totalCount = payload?.totalCount
        }
      )
      .addCase(getEntidadBancariaByIban.pending, (state) => {
        state.loadingEntidadBancaria = true
      })
      .addCase(getEntidadBancariaByIban.fulfilled, (state, { payload }) => {
        state.loadingEntidadBancaria = false
        state.entidadBancaria = payload
      })
      .addCase(getEntidadBancariaByIban.rejected, (state) => {
        state.loadingEntidadBancaria = false
      })
  },
})

export const {
  addNewEntidadBancaria,
  setIsSelectFilterActive,
  resetEntidadesBancarias,
  setEntidadBancaria,
} = entidadBancariaSlice.actions
